import { getWishlistMembership } from '../../api/wishlist/get-wishlist-membership';
import createBatchLoader, { BatchLoader } from '../../utils/create-batch-loader';
import { PAGINATION_LIMIT } from '../../utils/get-pagination-limit';
import { WishlistAuth } from './query-keys/query-keys';
import { WISHLIST_QUERY_URLS } from './wishlist.constants';

const createMembershipLoader = (url: string): BatchLoader<number, boolean> =>
    createBatchLoader(async (materialIds: number[]) => {
        const memberIds = new Set(await getWishlistMembership(url, materialIds));

        return new Map(materialIds.map((materialId) => [materialId, memberIds.has(materialId)]));
    }, PAGINATION_LIMIT);

export const wishlistMembershipLoaders: Record<WishlistAuth, BatchLoader<number, boolean>> = {
    user: createMembershipLoader(WISHLIST_QUERY_URLS.user),
    anonymous: createMembershipLoader(WISHLIST_QUERY_URLS.anonymous)
};
